module.exports = __webpack_public_path__ + "media/images/icon_reg-f3211416fd0ee5641dc9ed177358d9cf.png";